/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import fetchQuizResults from './action';

const quizResultsSlice = createSlice({
  name: 'quizResults',
  initialState: {
    results: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuizResults.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuizResults.fulfilled, (state, { payload }) => {
        state.results = payload || [];
        state.isLoading = false;
      })
      .addCase(fetchQuizResults.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      });
  },
});

export default quizResultsSlice.reducer;
